import styled from 'styled-components/macro';
import { SecondaryButton } from '../../../shared/Button';
import { fontWeightBold, fontWeightMedium } from '../../../styling/fonts';

export const ToggleButton = styled(SecondaryButton)<{ $isCurrent: boolean }>`
  opacity: ${props => (props.$isCurrent ? 1 : 0.75)};
  font-weight: ${props => (props.$isCurrent ? fontWeightBold : fontWeightMedium)};

  &:hover,
  &:focus {
    opacity: 1;
  }
`;
